<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Permitted Benefit</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Permitted Benefit</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Permitted Benefit</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap v-if="newMode">
              <v-flex xs6>
                <v-text-field
                  readonly
                  v-model="form.busCls"
                  :label="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                  data-vv-name="busCls"
                  :data-vv-as="labels.busCls"
                  v-validate="'required|max:4'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('busCls')"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="form.busCls !== '' || form.busCls !== undefined">
                <v-subheader class="queryLabel">{{ labels.busClsDescFromHelpList }}</v-subheader>
                <div class="queryValue">{{ busClsDescFromHelpList }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <div class="queryValue">{{ form.busCls }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.busClsDesc }}</v-subheader>
                <div class="queryValue">{{ busClsDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="newMode">
              <v-flex xs6>
                <v-text-field
                  readonly
                  v-model="form.benefit"
                  :label="labels.benefit"
                  :error-messages="errors.collect('benefit')"
                  data-vv-name="benefit"
                  :data-vv-as="labels.benefit"
                  v-validate="'required|max:4'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('benefit')"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="form.benefit !== '' || form.benefit !== undefined">
                <v-subheader class="queryLabel">{{ labels.benefitShortDescFromHelpList }}</v-subheader>
                <div class="queryValue">{{ benefitShortDescFromHelpList }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.benefit }}</v-subheader>
                <div class="queryValue">{{ form.benefit }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.benefitShortDesc }}</v-subheader>
                <div class="queryValue">{{ benefitShortDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox :readonly="queryMode" v-model="form.defBen" :label="labels.defBen"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.benLongDesc }}</v-subheader>
                <div class="queryValue">{{ form.benLongDesc }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.benLongDesc"
                  :label="labels.benLongDesc"
                  :error-messages="errors.collect('benLongDesc')"
                  data-vv-name="benLongDesc"
                  :data-vv-as="labels.benLongDesc"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn v-if="!queryMode" color="primary" @click="doSave" :loading="submitting">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
          <v-dialog v-model="busClsList" width="900px" persistent>
            <busCls-help-list v-if="busClsHelpList" :busCls="form.busCls" @close="doClose" @doAssign="doAssign($event)"></busCls-help-list>
          </v-dialog>
          <v-dialog v-model="benefitList" width="900px" persistent>
            <benefit-help-list v-if="benefitHelpList" :benefit="form.benefit" @close="doClose" @doAssign="doAssign($event)"></benefit-help-list>
          </v-dialog>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import BusClsHelpList from './BusClsHelpList.vue'
import BenefitHelpList from './BenefitHelpList.vue'
export default {
  data() {
    return {
      labels: {
        busCls: 'Business Class',
        busClsDescFromHelpList: 'Business Class Description',
        busClsDesc: 'Business Class Description',
        benefit: 'Benefit',
        benefitShortDescFromHelpList: 'Benefit Short Description',
        benefitShortDesc: 'Benefit Short Description',
        defBen: 'Default Benefit',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        benLongDesc: 'Benefit Long Description'
      },
      form: {
        busCls: '',
        benefit: '',
        defBen: false,
        benLongDesc: ''
      },
      busClsDesc: '',
      benefitShortDesc: '',
      busClsDescFromHelpList: '',
      benefitShortDescFromHelpList: '',
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      busClsHelpList: false,
      benefitHelpList: false,
      busClsList: false,
      benefitList: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getPmtBenefitPerBusCls
      if (apiURI) {
        this.loading = true
        await this.$http
          .put(apiURI, this.objParam)
          .then(result => {
            const { data } = result.data
            if (data) {
              this.form.busCls = data.pmtBenefitPerBusCls.busCls
              this.form.benefit = data.pmtBenefitPerBusCls.benefit
              this.form.defBen = data.pmtBenefitPerBusCls.defBen
              this.busClsDesc = data.pmtBenefitPerBusCls.busClsDesc
              this.benefitShortDesc = data.pmtBenefitPerBusCls.benefitDesc
              this.form.benLongDesc = data.pmtBenefitPerBusCls.benLongDesc
              this.createdBy = data.createdBy
              this.createdDate = data.createdDate
              this.modifiedBy = data.modifiedBy
              this.modifiedDate = data.modifiedDate
            }
            this.loading = false
          })
          .catch(err => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doCancel() {
      this.$router.push({ name: 'pmtBenefitPerBusClsList' })
    },
    getHelpList(fieldName) {
      if (fieldName === 'busCls') {
        this.busClsHelpList = true
        this.busClsList = true
      } else if (fieldName === 'benefit') {
        this.benefitHelpList = true
        this.benefitList = true
      }
    },
    doClose() {
      this.busClsHelpList = false
      this.busClsList = false
      this.benefitHelpList = false
      this.benefitList = false
    },
    doAssign(Obj) {
      if (Obj.from === 'busCls') {
        this.form.busCls = Obj.busCls.busCls
        this.busClsDescFromHelpList = Obj.busCls.busClsDesc
      }
      if (Obj.from === 'benefit') {
        this.form.benefit = Obj.benefit.benefit
        this.benefitShortDescFromHelpList = Obj.benefit.benefitShortDesc
      }
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createPmtBenefitPerBusCls
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updatePmtBenefitPerBusCls
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pmtBenefitPerBusCls.menu
    },
    modeParam() {
      return this.$route.params.pmtBenefitMode
    },
    objParam() {
      return this.$route.params.pmtBenefitObjRes
    }
  },
  created() {
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  mixins: [MessageMixin],
  components: {
    BusClsHelpList,
    BenefitHelpList
  }
}
</script>
